<template>
	<v-dialog
		v-model="open"
		max-width="700"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">SampleShowDIalog.vue</v-toolbar-title>
				<v-spacer></v-spacer>
        <!-- 詳細ページへのボタンはサンプル用 コピーしないこと -->
				<v-btn color="secondary" @click="$router.push({name:'sample_show'})">
					詳細ページ</v-btn
				>
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
        <!-- 削除や編集のアクション系のボタン -->
				<v-row no-gutters justify="end">
					<v-btn class="ml-auto mr-2" color="secondary" dense>
						<v-icon class="mr-2">mdi-pencil</v-icon>
						編集する</v-btn
					>
					<TemplateDeleteDialog />
				</v-row>

				<v-sheet elevation="0" class="mt-4">
          <!-- 中項目はある場合のみ 中項目が複数ある場合はテーブルを複数並べても良い-->
					<h4 class="text-h6 font-weight-bold color-secondary mb-2">中項目名(あれば)</h4>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr v-for="(key, i) in Object.keys(item)" :key="i">
								<th width="30%" class="font-weight-bold">{{ key }}</th>
								<td width="70%">{{ item[key] }}</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="$emit('close')"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		item: {
			type: Object,
			required: true,
			default: () => {},
		},
		text: Boolean,
	},
	components: {
		TemplateDeleteDialog,
	},
	data() {
		return {
			open: true,
		}
	},
	methods: {},
	computed: {},
	watch: {
		itemData(newValue, _) {
			this.item = newValue
		},
		deep: true,
	},
}
</script>
